import React, {useContext} from 'react'
import {SimpleTreeView} from '@mui/x-tree-view'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import TreeViewNodeComponent from './TreeViewNodeComponent'
import {DynamicComponentProps} from '../../../core/_models'

interface TreeViewComponentProps extends DynamicComponentProps {}

export default function TreeViewComponent({config, context}: TreeViewComponentProps) {
  const {data, action, id} = config

  const flatData: any[] = []
  const flattenData = (node: any) => {
    flatData.push(node)
    if (node.children != null && node.children.length > 0) {
      node.children.forEach((child: any) => flattenData(child))
    }
  }

  data.forEach((node: object) => flattenData(node))

  const formContext = useContext(context)

  const onSelectedItemsChange = (event: any, itemId: any) => {
    const filtered = flatData.filter((node) => node.id === parseInt(itemId))
    if (filtered.length > 0) {
      const node = filtered[0]

      if (node.children != null && node.children.length > 0) {
        return
      }

      if (action != null) {
        const values: any = {}
        values[id] = node.id
        formContext.submit({action, values})
      }
    }
  }

  return (
    <SimpleTreeView
      slots={{collapseIcon: ExpandMoreIcon, expandIcon: ChevronRightIcon}}
      sx={{height: 240, flexGrow: 1, maxWidth: 400, overflowY: 'auto'}}
      onSelectedItemsChange={onSelectedItemsChange}
    >
      {data.map((node: any) => (
        <TreeViewNodeComponent node={node} key={node.id} />
      ))}
    </SimpleTreeView>
  )
}
